<template>
	<div class="menuPage">
		<header class="main-header">
			<div class="logo" @click="$router.push('/menu')">
			</div>
			<div class="heard" ref="heardHg">
				<span>歡迎使用米因健康AI服務平台企業後台</span>
				<div class="msg">
					<el-popover placement="bottom" trigger="hover">
						<div class="login-out" @click="exitLogin">退出</div>
						<div slot="reference" class="user-info">
							<el-image class="user-avatar" :src="require('@/assets/images/avatar.png')"></el-image>
							<p>{{userInfo.username || "--"}} <i class="el-icon-caret-bottom"></i></p>
						</div>
					</el-popover>
				</div>
			</div>
		</header>
		<div class="main-content">
			<div class="menuBox" :class="isMenusHidden ? 'menusHidden' : ''">
				<ul>
					<li v-for="pRoute in menus" :key="pRoute.id">
						<div>
							<div @click="clickMenu(pRoute.id)" class="parent-route">
								<p>{{pRoute.name}}</p>
							<i v-if="clickMenuNum == pRoute.id" class="el-icon-arrow-down"></i>
							<i v-else class="el-icon-arrow-right"></i>
							</div>
							<div v-if="pRoute.son" v-show="clickMenuNum == pRoute.id" class="children-route">
								<router-link v-for="cRoute in pRoute.son" :key="cRoute.id" :to="cRoute.url">
									<div  class="list"
										:class="curRoute == cRoute.id ? 'listBoxClick':'listBox'"
										@click="selectCurRoute(cRoute.id)"
										>
										<span class="iconfont icon-taocankaitong"></span>{{cRoute.name}} 
									</div>
								</router-link>
							</div>
							
						</div>
						
					</li>
					</ul>
			</div>
			<div id="routerBox" class="routerBox">
				<div class="menu-show-btn" @click="isMenusHidden = !isMenusHidden">
					<i v-if="isMenusHidden" class="el-icon-arrow-right"></i>
					<i v-else class="el-icon-arrow-left"></i>
				</div>
				<div class="routerContent">
					<router-view @updateMenuNum="updateMenuNum" v-if="isRouterAlive"></router-view>
				</div>
			</div>
		</div>
		<Alert :hidden="alertShow" :tip-status="tipStatus" :tip-text="tipText" @on-close="closeDialog"
			@on-confirm="confirmDialog" />
	</div>
</template>

<script>
	import menu from '../assets/js/menu'
	import Alert from '../components/alert'
	export default {
		name: "menu",
		components: {
			Alert
		},
		...menu
	}
</script>

<style src="../assets/iconFonts/iconfont.css" scoped>
</style>
<style src="../assets/css/menu.css" scoped>
</style>


<style lang="scss" scoped>
	.login-out {
		width: 100%;
		text-align: center;
		cursor: pointer;
		padding: 4px 0;

		&:hover {
			background-color: #6883FB;
			color: #fff;
		}
	}
	
	.main-content{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		
		>div{
			position: relative;
			height: 100%;
			
		}
		
		.menuBox{
			flex: 0 0  auto;
			width: 180px;
		}
		
		
		
		.routerBox{
			flex: 1;
		}
		
		.menusHidden{
			width: 0 !important;
		}
		
		.routerContent{
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.menu-show-btn{
			position: fixed;
			top: 50%;
			transition: all 0.1s linear;
			width: 16px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			z-index: 99;
			 color: #333;
			border: 1px solid #00000040;
			border-left: none;
			cursor: pointer;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
		}
	}
	
	.parent-route{
		padding: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		user-select: none;
		font-weight: bold;
		color: #333;
	}
	
	.children-route{
		cursor: pointer;
	}
	
	.logo{
		cursor: pointer;
	}
	
	
	.user-info{
		display: flex;
		align-items: center;
		cursor: pointer;
		
		.user-avatar{
			width: 36px;
			height: 36px;
			margin-right: 12px;
		}
	}
</style>